module.exports = "/_next/static/images/dae4b220911fc17eb7772f6efc7e1afa-credit-card-autonomy@3x.png.webp";